import { lazy } from 'react';

export const PurchaseList = lazy(() => import('./PurchaseList'));
